// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-account-item__btn {
    margin: 0 0.4rem;
    font-size: 0.7rem;
    padding: 0 auto;
}

.contact-account-item__type-input {
    font-size: 1.8rem;
    display: inline-block;
    border: none;
    padding: 0 !important;
    width: 10rem;
}

.contact-account-item__type-input::-webkit-calendar-picker-indicator {
    opacity: 0;
    display: none;
}

.contact-account-item__id-input {
    margin: 0 !important;
}

.contact-account-item__login-input {
    margin: 0 !important;
}

.contact-account-item__type {
    font-size: 1.8rem;
    font-weight: 700;
    margin-top: 0.78rem;
    margin-bottom: 0.72rem;
    min-width: 8rem;
    max-width: 18rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.contact-account-item__id {
    display: block;
    font-weight: 700;
    margin-top: 0.78rem;
    margin-bottom: 0.72rem;
    min-width: 4rem;
    max-width: 8rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.contact-account-item__login {
    font-weight: 700;
    margin-top: 0.78rem;
    margin-bottom: 0.72rem;
    min-width: 8rem;
    max-width: 18rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.contact-account-item__btn-edit {
    background-color: #1696a6;
}

.contact-account-item__btn-delete {
    background-color: #d22e37;
}

.contact-account-item__btn-save {
    background-color: #d6ac17;
}

.contact-account-item__btn-save:focus {
    background-color: #d6ac17;
}

.contact-account-item__btn-replay {
    background-color: #d22e37;
}

.contact-account-item__type-toggle {
    background: none;
    border: none;
    box-shadow: none;
    text-transform: none;
    font-size: 1rem;
    padding-top: 0px;
    cursor: inherit;
    margin-left: 5rem;
    width: 0 !important;
    height: 5.4rem;
}

.contact-account-item__type-toggle:hover{
    background: none; 
    border: none; 
    box-shadow: none;
}

.contact-account-item__type-toggle:focus{
    background: none; 
}

.contact-account-item__type-menu {
    color: black;
    display: flex;
    flex-direction: column;
    left: -4.9rem !important;
    z-index: 10000;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
    max-height: 12rem;
    overflow-y: auto;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 50rem;
}

.contact-account-item__type-item {
    padding: 0.3rem 1.2rem 0.3rem 1.2rem;
    cursor: pointer;
    background-color: white;
    border: 0;
    text-align: left;
}

.contact-account-item__type-item:hover {
    background: #26a69a;
    color: #fff;
}

.contact-account-item__type-container .dropdown{
    width: 0;
}

.contact-account-item__type-container {
    display: flex;
    flex-direction: row;
}

.contact-account-item__table-row input.form-control {
    padding-bottom: 5px;
    height:auto;
}

.contact-account-item__type-container .contact-account-item__type-input {
    display: inline-block;
    padding: 0px 0px 0px 2.2px !important;
    height: 25px;
    margin: 0;
    line-height: normal;
    margin-top: 11.7px;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/contact-item-info/contact-account-list/contact-account-item/ContactAccountItem.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,cAAc;IACd,uGAAuG;IACvG,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".contact-account-item__btn {\r\n    margin: 0 0.4rem;\r\n    font-size: 0.7rem;\r\n    padding: 0 auto;\r\n}\r\n\r\n.contact-account-item__type-input {\r\n    font-size: 1.8rem;\r\n    display: inline-block;\r\n    border: none;\r\n    padding: 0 !important;\r\n    width: 10rem;\r\n}\r\n\r\n.contact-account-item__type-input::-webkit-calendar-picker-indicator {\r\n    opacity: 0;\r\n    display: none;\r\n}\r\n\r\n.contact-account-item__id-input {\r\n    margin: 0 !important;\r\n}\r\n\r\n.contact-account-item__login-input {\r\n    margin: 0 !important;\r\n}\r\n\r\n.contact-account-item__type {\r\n    font-size: 1.8rem;\r\n    font-weight: 700;\r\n    margin-top: 0.78rem;\r\n    margin-bottom: 0.72rem;\r\n    min-width: 8rem;\r\n    max-width: 18rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.contact-account-item__id {\r\n    display: block;\r\n    font-weight: 700;\r\n    margin-top: 0.78rem;\r\n    margin-bottom: 0.72rem;\r\n    min-width: 4rem;\r\n    max-width: 8rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.contact-account-item__login {\r\n    font-weight: 700;\r\n    margin-top: 0.78rem;\r\n    margin-bottom: 0.72rem;\r\n    min-width: 8rem;\r\n    max-width: 18rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.contact-account-item__btn-edit {\r\n    background-color: #1696a6;\r\n}\r\n\r\n.contact-account-item__btn-delete {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.contact-account-item__btn-save {\r\n    background-color: #d6ac17;\r\n}\r\n\r\n.contact-account-item__btn-save:focus {\r\n    background-color: #d6ac17;\r\n}\r\n\r\n.contact-account-item__btn-replay {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.contact-account-item__type-toggle {\r\n    background: none;\r\n    border: none;\r\n    box-shadow: none;\r\n    text-transform: none;\r\n    font-size: 1rem;\r\n    padding-top: 0px;\r\n    cursor: inherit;\r\n    margin-left: 5rem;\r\n    width: 0 !important;\r\n    height: 5.4rem;\r\n}\r\n\r\n.contact-account-item__type-toggle:hover{\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n}\r\n\r\n.contact-account-item__type-toggle:focus{\r\n    background: none; \r\n}\r\n\r\n.contact-account-item__type-menu {\r\n    color: black;\r\n    display: flex;\r\n    flex-direction: column;\r\n    left: -4.9rem !important;\r\n    z-index: 10000;\r\n    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n    max-height: 12rem;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    max-width: 50rem;\r\n}\r\n\r\n.contact-account-item__type-item {\r\n    padding: 0.3rem 1.2rem 0.3rem 1.2rem;\r\n    cursor: pointer;\r\n    background-color: white;\r\n    border: 0;\r\n    text-align: left;\r\n}\r\n\r\n.contact-account-item__type-item:hover {\r\n    background: #26a69a;\r\n    color: #fff;\r\n}\r\n\r\n.contact-account-item__type-container .dropdown{\r\n    width: 0;\r\n}\r\n\r\n.contact-account-item__type-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.contact-account-item__table-row input.form-control {\r\n    padding-bottom: 5px;\r\n    height:auto;\r\n}\r\n\r\n.contact-account-item__type-container .contact-account-item__type-input {\r\n    display: inline-block;\r\n    padding: 0px 0px 0px 2.2px !important;\r\n    height: 25px;\r\n    margin: 0;\r\n    line-height: normal;\r\n    margin-top: 11.7px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
